import { EARLIEST_BUSINESS_DATE, isCalendarDate } from '@nudool/shared';

import { parseIdList } from '../accounts-receivable/parse-ar-report-search.js';

export const ACCOUNT_ACTIVITY_TAB = 'account-activity';

const CUSTOMER_DETAIL_TABS = [
  'sales',
  'events',
  'pricing',
  'credits',
  'brands',
  ACCOUNT_ACTIVITY_TAB,
  'activity',
];

// The first view is the default and is left out of the URL.
export const CUSTOMER_AR_LEDGER_VIEWS = ['activity', 'orders'] as const;

export type CustomerArLedgerView = (typeof CUSTOMER_AR_LEDGER_VIEWS)[number];

// Defaults are left out of the URL: no `to` means today, no `from` means 12 months before it, no `view` means Activity.
export type CustomerArLedgerSearch = {
  from?: string;
  to?: string;
  brandIds?: string[];
  includeCredits?: boolean;
  view?: Exclude<CustomerArLedgerView, 'activity'>;
};

export type CustomerDetailSearch = CustomerArLedgerSearch & {
  tab?: string;
};

export type CustomerDetailSearchPatch = {
  [Key in keyof CustomerDetailSearch]?: CustomerDetailSearch[Key] | undefined;
};

function parseBusinessDate(value: unknown): string | undefined {
  return typeof value === 'string' && isCalendarDate(value) && value >= EARLIEST_BUSINESS_DATE
    ? value
    : undefined;
}

// Shape-only and never throws, so a hand-edited URL falls back to the defaults.
export function parseCustomerDetailSearch(search: Record<string, unknown>): CustomerDetailSearch {
  const parsed: CustomerDetailSearch = {};

  const tab = CUSTOMER_DETAIL_TABS.find((candidate) => candidate === search.tab);
  if (tab) parsed.tab = tab;

  const from = parseBusinessDate(search.from);
  if (from) parsed.from = from;
  const to = parseBusinessDate(search.to);
  if (to) parsed.to = to;

  const brandIds = parseIdList(search.brandIds);
  if (brandIds) parsed.brandIds = brandIds;

  if (search.includeCredits === true) parsed.includeCredits = true;
  if (search.view === 'orders') parsed.view = 'orders';

  return parsed;
}
